import React from 'react';
import styles from './TitleCard.module.scss';
import { Button } from 'antd';

const TitleCard = ({ title, openForm, icon = 'history' }) => {
  return (
    <div className={styles.conteiner}>
      <div>{title}</div>
      {typeof openForm === 'function' && (
        <Button
          onClick={openForm}
          type="link"
          icon={icon}
        />
      )}
    </div>
  );
};

export default TitleCard;
